<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1"><span>Lovers</span></h1>
<h2 class="P_Heading_2"><span>The Irish Castle</span></h2>
<p class="P_Body_Text_2"><span>The Glenncailty Ghosts, Book 2</span></p>
<p class="P_Body_Text_3"><span>Lila Dubois</span></p>
<p class="P_Body_Text">Published 2017 by Book Boutiques.</p>
<p class="P_Body_Text">ISBN: 978-1-946363-61-9</p>
<p class="P_Body_Text">Copyright © 2017, Lila Dubois.</p>
<p class="P_Body_Text">All rights reserved.</p>
<p class="P_Body_Text">No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, recording, or otherwise, without the prior written permission of Book Boutiques.</p>
<p class="P_Body_Text">This book is a work of fiction. Any similarity to actual persons, living or dead, locales, or events is wholly coincidental. The names, characters, dialogue, and events in this book are from the author’s imagination and should not to be construed as real.</p>
<p class="P_Body_Text">Manufactured in the USA.</p>
<p class="P_Body_Text">Email support@bookboutiques.com with questions, or inquiries about Book Boutiques.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?23992c1f